<template>
	<div class="range-slider">
		<input
			type="range"
			@mouseup="changed"
			v-model="value"
			min="-5"
			max="5"
			step="1"
			name="approval"
		>
	</div>
</template>

<script>
export default {
	name: "range-slider",
	props: ["min", "max", "step", "name", "actorApprovalRating"],
	data: function () {
		return {
			value: this.actorApprovalRating || 0,
		};
	},
	mounted() {},
	beforeDestroy() {
		// pp.log("RANGE SLIDER beforeDestroy")
	},
	destroyed() {
		// pp.log("RANGE SLIDER afterDestroy")
	},
	methods: {
		changed() {
			console.log("Slider changed:", this, this.$el.children[0]);
			this.$nextTick(() => {
				pp.vue.bus.$emit(
					"approval_rating-CREATE",
					// @ts-expect-error
					parseInt(this.$el.children[0].value),
				);
			});
		},
	},
};
</script>
